"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificatesList = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var List_1 = require("./List");

var searchHelper_1 = require("./searchHelper");

var Search_1 = require("./Search");

var Errors_1 = require("../Errors");

var CertificatesList_module_css_1 = tslib_1.__importDefault(require("./CertificatesList.module.css"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var PluginHint_1 = require("./PluginHint");

var Modal_1 = require("@skbkontur/react-ui/components/Modal");

var react_ui_1 = require("@skbkontur/react-ui");

var configuration_1 = require("../../contexts/configuration");

var CertificatesList =
/** @class */
function (_super) {
  tslib_1.__extends(CertificatesList, _super);

  function CertificatesList(props) {
    var _this = _super.call(this, props) || this;

    _this.onSearchChange = function (searchQuery) {
      var items = _this.props.items;

      var itemsBySearchQuery = _this.processBySearchQuery(items, searchQuery);

      _this.setState({
        searchQuery: searchQuery,
        items: itemsBySearchQuery
      });
    };

    _this.processBySearchQuery = function (items, searchQuery) {
      if (!searchQuery) {
        return items;
      }

      var searchResult = searchHelper_1.search(searchQuery, items.map(function (item) {
        return item.certificate;
      }));
      return items.filter(function (item) {
        return searchResult[item.certificate.thumbprint()];
      }).map(function (item) {
        return tslib_1.__assign(tslib_1.__assign({}, item), {
          searchMatchedInfo: searchResult[item.certificate.thumbprint()]
        });
      }); // спред чтобы searchMatchedInfo не добавлялись к исходным элементам массива item
    };

    _this.state = {
      searchQuery: '',
      items: props.items
    };
    _this.initItemsCount = props.items.length;
    return _this;
  }

  CertificatesList.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var searchQuery = this.state.searchQuery;
    var items = nextProps.items;
    this.initItemsCount = items.length;
    var itemsBySearchQuery = this.processBySearchQuery(items, searchQuery);
    this.setState({
      items: itemsBySearchQuery
    });
  };

  CertificatesList.prototype.render = function () {
    var _a;

    var _b = this.context,
        showSearchCertCount = _b.showSearchCertCount,
        pluginFullInfo = _b.pluginFullInfo,
        pageSize = _b.pageSize,
        modalOptions = _b.modalOptions,
        showLoader = _b.showLoader;
    var _c = this.state,
        items = _c.items,
        searchQuery = _c.searchQuery;

    if (items.length === 0) {
      this.context.trackEvent('noSearchResult', searchQuery.slice(0, 15));
    }

    var showSearch = this.initItemsCount >= showSearchCertCount; // в случае отображения списка в модалке, поиск должен залипть сверху с отступом
    // равным высоте хедера модалки.

    var searchOffset = modalOptions ? 76 : 0;
    var listWithSearch = react_1.default.createElement(react_ui_1.Loader, {
      active: !!showLoader
    }, showSearch ? react_1.default.createElement(Search_1.Search, {
      offset: searchOffset,
      onChange: this.onSearchChange,
      view: this.context.view
    }) : null, react_1.default.createElement("div", {
      className: classnames_1.default((_a = {}, _a[CertificatesList_module_css_1.default.searchSplitter] = showSearch, _a))
    }, items.length === 0 ? react_1.default.createElement(Errors_1.NoSearchResults, {
      view: this.context.view
    }) : react_1.default.createElement(List_1.List, {
      items: items,
      pageSize: pageSize
    })), pluginFullInfo && pluginFullInfo.state.ready === false && pluginFullInfo.pluginAvailableError === undefined ? react_1.default.createElement(PluginHint_1.PluginHint, {
      errorCode: pluginFullInfo.state.error.code
    }) : null);

    if (modalOptions) {
      var caption = modalOptions.caption,
          width = modalOptions.width,
          onClose = modalOptions.onClose,
          before = modalOptions.before,
          after = modalOptions.after,
          ignoreBackgroundClick = modalOptions.ignoreBackgroundClick,
          footerContent = modalOptions.footerContent,
          footerParams = modalOptions.footerParams; // Отступы для текстов до и после, и для самих сертов, скопированы из Modal.Body.

      return react_1.default.createElement(Modal_1.Modal, {
        "data-tid": "modal_certificates",
        width: width,
        onClose: onClose,
        ignoreBackgroundClick: ignoreBackgroundClick
      }, react_1.default.createElement(Modal_1.Modal.Header, null, caption), before && react_1.default.createElement("div", {
        className: CertificatesList_module_css_1.default.beforeBlock
      }, before), listWithSearch, after && react_1.default.createElement("div", {
        className: CertificatesList_module_css_1.default.afterBlock
      }, after), footerContent && react_1.default.createElement(Modal_1.Modal.Footer, tslib_1.__assign({}, footerParams), footerContent));
    } else {
      return listWithSearch;
    }
  };

  CertificatesList.contextType = configuration_1.configurationContext;
  return CertificatesList;
}(react_1.default.Component);

exports.CertificatesList = CertificatesList;